"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueryClient = exports.ReactQueryProvider = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var react_1 = __importDefault(require("react"));
var react_query_1 = require("react-query");
/**
 *
 * Returns a QueryClientProvider that contains client defaults as follows, passing in custom config will override default values
 *
 ```
 defaultOptions: {
    queries: {
      cacheTime: 300000,
        staleTime: 300000,
        refetchOnWindowFocus: false,
        retry: false,
      },
  },
 ```
 *
 */
var ReactQueryProvider = function (_a) {
    var children = _a.children, config = _a.config;
    return (react_1.default.createElement(react_query_1.QueryClientProvider, { client: (0, exports.createQueryClient)(config) }, children));
};
exports.ReactQueryProvider = ReactQueryProvider;
var createQueryClient = function (config) {
    return new react_query_1.QueryClient((0, deepmerge_1.default)({
        defaultOptions: {
            queries: {
                cacheTime: 300000,
                staleTime: 300000,
                refetchOnWindowFocus: false,
                retry: false,
            },
        },
    }, config || {}));
};
exports.createQueryClient = createQueryClient;
